import React, {useState, useMemo} from "../../../../__snowpack__/pkg/react.js";
import {Modal, Button, Form, Pagination, Spin, Checkbox, message, Row, Col} from "../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {useBoolean, useRequest} from "../../../../__snowpack__/pkg/ahooks.js";
import {request} from "../../../utils/request/index.js";
import GnAlert from "../../GnAlert/index.js";
import {UploaderDrag} from "../../UploaderDrag2.js";
import noProductIcon from "../../../assets/no-product-icon.png";
import {PopoverImg} from "../../PopoverImg/index.js";
import SearchForm from "../../SearchForm/index.js";
import useTable from "../../../hooks/mutations/useTable/index.js";
import EllipsisTooltip from "../EllipsisTooltip/index.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {ResultModal} from "./ResultModal.js";
const ModalWrapper = styled(Modal)`
  .modalWrapper {
  }
  .imgWrapper {
    margin: 0 5px;
  }
  .nameWrapper {
    width: 100px;
  }
  .ant-checkbox-wrapper {
    display: flex;
    align-items: flex-start;
  }
`;
export default function index(props) {
  const {formatMessage} = useIntl();
  const {shopIds, channelId, countryCode} = props;
  const [visible, {toggle, setTrue, setFalse}] = useBoolean(false);
  const [taskId, setTaskId] = useState("");
  const [selectList, setSelectList] = useState([]);
  const [form] = Form.useForm();
  const [imageForm] = Form.useForm();
  const statusList = [
    {label: formatMessage({id: "status_live"}), value: "ACTIVE"},
    {
      label: formatMessage({id: "status_disabled"}),
      value: "DISABLED"
    },
    {
      label: formatMessage({id: "status_sold_out"}),
      value: "SOLD_OUT"
    }
  ];
  const selectIds = useMemo(() => {
    return selectList?.map((item) => item?.id) || [];
  }, [selectList]);
  const {loading: submitLoading, runAsync: runSubmit} = useRequest((params) => request.post(`/saas/product/batch-update-product-info`, params), {
    manual: true
  });
  const {
    data: productData,
    loading,
    pagination,
    search
  } = useTable(({page, size, status, keyword}) => {
    return request.post(`/saas/product/v1/products/search?page=${page}&size=${size}`, {
      keywordType: "PRODUCT_NAME",
      keyword,
      channelId,
      countryCode,
      hasChildrenCategory: false,
      shopIds,
      status
    });
  }, {
    form,
    manual: true
  });
  const {list = []} = productData || {};
  const handleShowModal = () => {
    setTrue();
    search.submit();
    form.resetFields();
    imageForm.resetFields();
  };
  const handleSelectItem = (record) => {
    const findIndex = selectList?.findIndex((item) => item?.id == record.id);
    if (findIndex >= 0) {
      const copyList = [...selectList];
      copyList.splice(findIndex, 1);
      setSelectList(copyList);
    } else {
      setSelectList([...selectList, record]);
    }
  };
  const handleSubmit = async () => {
    try {
      const values = await imageForm.validateFields() || {};
      const {images = []} = values;
      const filterImages = images?.filter((data) => data).map((_) => _.response);
      if (filterImages?.length == 0) {
        message.info("please upload image");
        return;
      }
      if (selectIds?.length == 0) {
        message.info(formatMessage({id: "stepSelectTheProductYou"}));
        return;
      }
      const submitParams = {
        channelId,
        infoVOList: selectList.map((item) => {
          const {id, shopId, shopName} = item;
          return {
            shopName,
            shopId,
            productId: id,
            pictureList: filterImages.map((url) => {
              return {
                url
              };
            })
          };
        })
      };
      const taskId2 = await runSubmit(submitParams);
      setTaskId(taskId2);
    } catch (error) {
      console.log("massSetImage error", error);
    }
  };
  const imageTip = useMemo(() => {
    if (channelId == "TIKTOK_ID") {
      return formatMessage({id: "productImageTip"}, {
        maxLength: 9,
        size: 5,
        width: 600,
        height: 600
      });
    }
    if (channelId == "SHOPEE_ID") {
      return formatMessage({id: "productImageTip"}, {
        maxLength: 9,
        size: 4,
        width: 300,
        height: 300
      });
    }
    return "";
  }, [channelId]);
  const imageRules = useMemo(() => {
    if (channelId == "TIKTOK_ID") {
      return [
        {
          required: true,
          validator: (rule, value = []) => {
            const imageLength = value?.filter((data) => data).map((_) => _.response)?.length;
            if (imageLength < 1 || imageLength > 9) {
              return Promise.reject(formatMessage({id: "theRangeOfProductImagesThat"}, {min: 1, max: 9}));
            }
            return Promise.resolve();
          }
        }
      ];
    }
    if (channelId == "SHOPEE_ID") {
      return [
        {
          required: true,
          validator: (rule, value = []) => {
            const imageLength = value?.filter((data) => data).map((_) => _.response)?.length;
            if (imageLength < 1 || imageLength > 9) {
              return Promise.reject(formatMessage({id: "theRangeOfProductImagesThat"}, {min: 1, max: 9}));
            }
            return Promise.resolve();
          }
        }
      ];
    }
    return [];
  }, [channelId]);
  const limitRule = useMemo(() => {
    if (channelId == "SHOPEE_ID") {
      return {
        limitNum: 9,
        size: 4
      };
    }
    if (channelId == "TIKTOK_ID") {
      return {
        limitNum: 9,
        size: 5
      };
    }
    return {
      limitNum: 9,
      size: 4
    };
  }, [channelId]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: handleShowModal
  }, formatMessage({id: "editImagesInBatches"})), /* @__PURE__ */ React.createElement(ModalWrapper, {
    visible,
    onCancel: toggle,
    onOk: handleSubmit,
    confirmLoading: submitLoading,
    title: formatMessage({id: "editImagesInBatches"}),
    width: 600
  }, /* @__PURE__ */ React.createElement("div", {
    className: "modalWrapper"
  }, /* @__PURE__ */ React.createElement(GnAlert, {
    message: imageTip
  }), /* @__PURE__ */ React.createElement("h3", null, formatMessage({id: "stepConfirmThePictureInformation"})), /* @__PURE__ */ React.createElement(Form, {
    form: imageForm
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "images",
    rules: imageRules
  }, /* @__PURE__ */ React.createElement(UploaderDrag, {
    listType: "picture-card",
    limitNum: 9,
    limitSizeM: limitRule?.size,
    limitWH: channelId == "TIKTOK_ID" ? [600, 600] : [300, 300],
    invalidSizeMsg: imageTip,
    onChange: (files) => {
      imageForm.setFieldsValue({images: files || []});
      imageForm.validateFields(["images"]);
    },
    invalidWhMsg: imageTip,
    itemTitleRender: (index2) => {
      if (index2 === 0) {
        return formatMessage({id: "main"});
      }
      return `${formatMessage({id: "main"})} ${index2}`;
    },
    uploadProps: {
      multiple: true
    }
  }))), /* @__PURE__ */ React.createElement("h3", null, formatMessage({id: "stepSelectTheProductYou"})), /* @__PURE__ */ React.createElement("div", {
    className: ""
  }, /* @__PURE__ */ React.createElement(SearchForm, {
    search,
    form
  }, /* @__PURE__ */ React.createElement(SearchForm.Simple, null, /* @__PURE__ */ React.createElement(SearchForm.Item, {
    name: "status",
    prefabKey: "Select",
    initialValue: "ACTIVE",
    componentProps: {
      options: statusList,
      style: {width: 120}
    }
  }), /* @__PURE__ */ React.createElement(SearchForm.Item, {
    componentProps: {
      placeholder: formatMessage({id: "pleaseEnterProductName"})
    },
    name: "keyword",
    prefabKey: "Input",
    initialValue: ""
  }))), /* @__PURE__ */ React.createElement(Spin, {
    spinning: loading
  }, list?.length > 0 ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, {
    gutter: [8, 8]
  }, list.map((product) => {
    const {id, name, image} = product;
    return /* @__PURE__ */ React.createElement(Col, {
      span: 12
    }, /* @__PURE__ */ React.createElement(Checkbox, {
      checked: selectIds?.includes(id),
      onChange: () => {
        handleSelectItem(product);
      }
    }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("div", {
      className: "imgWrapper"
    }, /* @__PURE__ */ React.createElement(PopoverImg, {
      avatarSize: 54,
      previewImage: image || noProductIcon
    })), /* @__PURE__ */ React.createElement("div", {
      className: "nameWrapper",
      style: {flex: 1}
    }, /* @__PURE__ */ React.createElement(EllipsisTooltip, {
      title: name,
      placement: "topLeft"
    })))));
  })), /* @__PURE__ */ React.createElement(Row, {
    justify: "end",
    style: {marginTop: "8px"}
  }, /* @__PURE__ */ React.createElement(Pagination, {
    ...pagination,
    showSizeChanger: false,
    onChange: (...args) => {
      pagination?.onChange(...args);
    }
  }))) : formatMessage({id: "globalNoEmptyText"}))))), /* @__PURE__ */ React.createElement(ResultModal, {
    channelId,
    CopyTaskInfo: {taskId},
    handelCancelResults: () => {
      setTaskId("");
    },
    IsSuccessVisible: !!taskId
  }));
}
